import { Job } from './../../models/job.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'mj-job-info-due-date-card',
  templateUrl: './job-info-due-date-card.component.html',
  styleUrls: ['./job-info-due-date-card.component.scss'],
})
export class JobInfoDueDateCardComponent implements OnInit {
  @Input() job: Job;
  @Output() onJobChanged: EventEmitter<Job> = new EventEmitter<Job>();

  _today = new Date();
  _dueDate: Date;

  set dueDate(value: Date) {
    this._dueDate = value;
    const newDueDate = value
      ? new DatePipe(this.translate.currentLang).transform(
          value,
          'yyyy-MM-dd h:mm:ssZ'
        )
      : null;
    this.onJobChanged.emit({ ...this.job, due_date: newDueDate });
  }

  constructor(public translate: TranslateService) {}

  public ngOnInit() {
    this.initializeDueDate();
  }

  private initializeDueDate() {
    if (!this.job.due_date) {
      // just set calendar to today
      this._dueDate = this.generateNextMonthDate();
    } else if (this.job.due_date && this._today < new Date(this.job.due_date)) {
      this.dueDate = new Date(this.job.due_date);
    } else {
      this.dueDate = this.generateNextMonthDate();
    }
  }

  toggleOpenApplication() {
    if (this.job.due_date) {
      this.dueDate = null;
    } else {
      this.dueDate = this.generateNextMonthDate();
    }
  }

  generateNextMonthDate() {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    return date;
  }
}
